import { TAdminPanelConfigChild } from 'screens/AdminPanel/AdminPanel.types';

export const hasSelectedChild = (
  selectedId: string,
  children: Array<TAdminPanelConfigChild>
) => children.some((child) => child.id === selectedId);
